import { toNote } from '@/lib/link'
import { cn } from '@/lib/utils'
import { Event } from '@nostr/tools/wasm'
import { useTranslation } from 'react-i18next'

export default function VideoNotePreview({
  event,
  className
}: {
  event: Event
  className?: string
}) {
  const { t } = useTranslation()

  return (
    <div className={cn('pointer-events-none', className)}>
      [{t('Media')}]{' '}
      <a href={toNote(event)} onClick={(e) => e.preventDefault()} className="italic pr-0.5">
        {event.content}
      </a>
    </div>
  )
}
